import React from "react";
import ExcoKelurahan from "../../components/organism/ExcoKelurahan";

const PageExcoKelurahan = () => {
  return (
    <>
      <ExcoKelurahan />
    </>
  );
};

export default PageExcoKelurahan;
